export default {"src":"/_next/static/media/plus-sign.658a5580.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};